/**
 * Minimal CSS-columns masonry stub (vue-masonry-css is Vue 2 only).
 * Preserves cols/gutter props used by TasksList.
 */
export default {
  name: 'MasonryStub',
  props: {
    cols: {
      type: [Number, Object],
      default: 2,
    },
    gutter: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    columnCount() {
      if (typeof this.cols === 'number') {
        return this.cols;
      }
      if (this.cols && typeof this.cols === 'object') {
        return this.cols.default || this.cols[Object.keys(this.cols)[0]] || 2;
      }
      return 2;
    },
    style() {
      const gutter = typeof this.gutter === 'number' ? `${this.gutter}px` : this.gutter;
      return {
        columnCount: this.columnCount,
        columnGap: gutter,
      };
    },
  },
  template: '<div class="masonry-stub" :style="style"><slot /></div>',
};
